module.exports = __webpack_public_path__ + "7820d5941a6031ec820906b91c64c451.png";